(function (module) {
    "use strict";

    module.component('assumptionsCard', {
        template: require('./assumptionsCardComponent.html'),
        bindings: {
            isValid: '=',
            brandName: '<',
            showValidationErrors: "=",
            assumptionCard: "=",
            riskData: "=",
            isEditable: "="
        },
        controller: ['$scope', function(this: $TSFixMe, $scope: $TSFixMe) {
            var $ctrl = this;

            $ctrl.addRisk = function (data: $TSFixMe, date: $TSFixMe) {
                if (!$ctrl.isEditable)
                    return;
                if (data && date) {
                    $ctrl.riskData.push({
                        risk: data,
                        date: date
                    });
                    $ctrl.risk = "";
                    $ctrl.riskDate = null;
                    $ctrl.riskRequired = false;
                    $ctrl.dateRequired = false;
                    return;
                }
                $ctrl.riskRequired = !data;
                $ctrl.dateRequired = !date;
            };

            $ctrl.removeItem = function (item: $TSFixMe) {
                $ctrl.riskData.splice(item, 1);
                $ctrl.riskRequired = false;
                $ctrl.dateRequired = false;
            };



            $ctrl.$onInit = function () {
                $ctrl.showValidationErrors = function () {
                    $ctrl.assumptionCardForm['marketInfoMore'].$touched = true;
                    $ctrl.assumptionCardForm['productInfoMore'].$touched = true;
                    $ctrl.assumptionCardForm['moleculeInfoMore'].$touched = true;
                    $ctrl.assumptionCardForm['refundactionAssumptions'].$touched = true;
                    $ctrl.assumptionCardForm['priceAssets'].$touched = true;
                    $ctrl.assumptionCardForm['promotionalForces'].$touched = true;
                    $ctrl.assumptionCardForm['promotionalForcesCompetitors'].$touched = true;
                };

                $scope.$watch('$ctrl.assumptionCardForm.$valid', function (newValue: $TSFixMe) {
                    $ctrl.isValid = newValue;
                });

            }

        }]
    })

})(angular.module('topline.modules'));